import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';
import memoize from 'moize';

export const transformCamelCaseKeysToSnakeCase = memoize.deep((data: any) =>
  mapKeys(data, (_, key) => snakeCase(key))
);
